export const HOME_LIST = 'HOME_LIST';
export const HOME_LIST_SUCCESS = 'HOME_LIST_SUCCESS';
export const HOME_LIST_FAIL = 'HOME_LIST_FAIL';

export const CREATE_HOME_ITEM = 'CREATE_HOME_ITEM';
export const CREATE_HOME_ITEM_SUCCESS = 'CREATE_HOME_ITEM_SUCCESS';
export const CREATE_HOME_ITEM_FAIL = 'CREATE_HOME_ITEM_FAIL';

export const UPDATE_HOME_ITEM = 'UPDATE_HOME_ITEM';
export const UPDATE_HOME_ITEM_SUCCESS = 'UPDATE_HOME_ITEM_SUCCESS';
export const UPDATE_HOME_ITEM_FAIL = 'UPDATE_HOME_ITEM_FAIL';

export const DELETE_HOME_ITEM = 'DELETE_HOME_ITEM';
export const DELETE_HOME_ITEM_SUCCESS = 'DELETE_HOME_ITEM_SUCCESS';
export const DELETE_HOME_ITEM_FAIL = 'DELETE_HOME_ITEM_FAIL';

export const UPDATE_HOME_POST = 'UPDATE_HOME_POST';
export const UPDATE_HOME_POSTLIST = 'UPDATE_HOME_POSTLIST';
export const UPDATE_HOME_POST_FAIL = 'UPDATE_HOME_POST_FAIL';